export enum DetailType {
    ADD = 'add',
    EDIT = 'edit',

}

export enum ExcelUploadType {
    BASIC= 1, // 基础库
    SPECIMEN = 2, // 植物标本
    ORIGINAL = 3, // 原植物图库
    ATLAS = 4, // 图谱库
    DNA = 5, // dna序列库
}

export enum ManagerBusinessType {
    BASIC= 1, // 基础库
    SPECIMEN = 2, // 植物标本
    ORIGINAL = 3, // 原植物图库
    ATLAS = 4, // 图谱库
    DNA = 5, // dna序列库
}